/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useMemo, useRef, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import { config, fetchData, toasterrormsg, toastsuccessmsg, useMenuIdPermissions } from '../../../../reusable'
import { PageTitle } from '../../../../_metronic/layout/core'
import { Tr } from '../../../../_metronic/i18n/Tr'
import JoditEditor from 'jodit-react'

const ViewCouponPrecautions = () => {
  let t = Tr()
  const { menuIdEdit } = useMenuIdPermissions()
  const tmp = sessionStorage.getItem('admin')
  const adminId = tmp ? JSON.parse(tmp)?.adminId ?? '' : ''

  const enPrecautionRef = useRef(null) as any
  const ruPrecautionRef = useRef(null) as any
  const uzPrecautionRef = useRef(null) as any

  const [error, setError] = useState(Object)
  const [enCouponPrescription, setEnCouponPrescription] = useState('')
  const [ruCouponPrescription, setRuCouponPrescription] = useState('')
  const [uzCouponPrescription, setUzCouponPrescription] = useState('')
  const [couponPrecautionLoading, setCouponPrecautionLoading] = useState(false)
  const editorConfig300 = useMemo(() => config(300), [])

  const viewCouponPrecautionsApiCall = async () => {
    var res = await fetchData('admin/viewTimeAndPhoneGlobalSettings', {})

    if (res.status == '200') {
      var data = res.data
      setEnCouponPrescription(data.en_precaution)
      setRuCouponPrescription(data.ru_precaution)
      setUzCouponPrescription(data.uz_precaution)
    } else {
      toasterrormsg(res.message)
    }
  }

  useEffect(() => {
    viewCouponPrecautionsApiCall()
    document.title = 'Insayr | Coupon Precautions'
  }, [])

  const removeError2 = (err: any) => {
    var tmp = Array.isArray(error) ? [...error] : [{}]
    if (!tmp[0]) tmp[0] = {}
    tmp[0][err] = ''
    setError(tmp)
  }

  const couponPrescriptionValidation = () => {
    let err = 0
    var errorTmp = Array.isArray(error) ? [...error] : [{}]

    if (enCouponPrescription == '' || enCouponPrescription == null || enCouponPrescription == undefined) {
      errorTmp[0].enCouponPrescription = t('English Coupon Description Is Required')
      err = 1
    }
    if (ruCouponPrescription == '' || ruCouponPrescription == null || ruCouponPrescription == undefined) {
      errorTmp[0].ruCouponPrescription = t('Russian Coupon Description Is Required')
      err = 1
    }
    if (uzCouponPrescription == '' || uzCouponPrescription == null || uzCouponPrescription == undefined) {
      errorTmp[0].uzCouponPrescription = t('Uzbek Coupon Description Is Required')
      err = 1
    }

    setError(errorTmp)
    if (err === 0) {
      saveCouponPrescription()
    }
  }

  const saveCouponPrescription = async () => {
    setCouponPrecautionLoading(true)
    const param = {
      adminId,
      en_precaution: enCouponPrescription,
      ru_precaution: ruCouponPrescription,
      uz_precaution: uzCouponPrescription,
    }
    var res = await fetchData('admin/timeAndPhoneGlobalSettings', param)

    if (res.status == '200') {
      toastsuccessmsg(res.message)
      viewCouponPrecautionsApiCall()
      setCouponPrecautionLoading(false)
    } else {
      toasterrormsg(res.message)
      setCouponPrecautionLoading(false)
    }
  }

  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('Coupon Precautions')}</PageTitle>

      <div className='card mb-5 mb-xl-10 col-lg-12' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>{t('Coupon Precautions')}</h3>
          </div>
        </div>

        <div className='card-body py-0 pb-10'>
          <div className='row'>
            <div className='col-lg-6 mt-6'>
              <label className='fw-bold text-muted'>{t('English Coupon Prescription')}</label>
              <div className='d-flex align-items-center'>
                <JoditEditor
                  ref={enPrecautionRef}
                  config={editorConfig300}
                  value={enCouponPrescription}
                  onBlur={(newContent) => {
                    setEnCouponPrescription(newContent)
                    removeError2('enCouponPrescription')
                  }}
                />
              </div>
              <label className='text-danger'>
                {error && error[0] && error[0].enCouponPrescription ? error[0].enCouponPrescription : ''}
              </label>
            </div>

            <div className='col-lg-6 mt-6'>
              <label className='fw-bold text-muted'>{t('Russian Coupon Prescription')}</label>
              <div className='d-flex align-items-center'>
                <JoditEditor
                  ref={ruPrecautionRef}
                  config={editorConfig300}
                  value={ruCouponPrescription}
                  onBlur={(newContent) => {
                    setRuCouponPrescription(newContent)
                    removeError2('ruCouponPrescription')
                  }}
                />
              </div>
              <label className='text-danger'>
                {error && error[0] && error[0].ruCouponPrescription ? error[0].ruCouponPrescription : ''}
              </label>
            </div>

            <div className='col-lg-6 mt-6'>
              <label className='fw-bold text-muted'>{t('Uzbek Coupon Prescription')}</label>
              <div className='d-flex align-items-center'>
                <JoditEditor
                  ref={uzPrecautionRef}
                  config={editorConfig300}
                  value={uzCouponPrescription}
                  onBlur={(newContent) => {
                    setUzCouponPrescription(newContent)
                    removeError2('uzCouponPrescription')
                  }}
                />
              </div>
              <label className='text-danger'>
                {error && error[0] && error[0].uzCouponPrescription ? error[0].uzCouponPrescription : ''}
              </label>
            </div>
          </div>

          {menuIdEdit ? (
            <button
              className='btn btn-success mt-4'
              disabled={couponPrecautionLoading}
              onClick={() => {
                couponPrescriptionValidation()
              }}
            >
              {!couponPrecautionLoading && t('Save')}
              {couponPrecautionLoading && (
                <span className='indicator-progress' style={{ display: 'block' }}>
                  {t('Please wait...')}{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          ) : (
            ''
          )}
        </div>
      </div>
    </>
  )
}

export { ViewCouponPrecautions }